import { OLIVEOIL_SERVICE } from "@/services/oliveOil.service.js";

const state = { listOutput: null, detailOutput: null};

const actions = {
    getList({ dispatch, commit }, inputGetOliveOils) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        OLIVEOIL_SERVICE.list(inputGetOliveOils)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getDetails({ dispatch, commit }, slug) {
        dispatch('alert/clear', null, { root: true });
        commit('listDetailRequest');
        
        OLIVEOIL_SERVICE.getDetail(slug)
            .then(
                output => {
                    commit('listDetailSuccess', output);
                },
                error => {
                    commit('listDetailFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        setTimeout(() => state.listOutput = output, 1000);
    },
    listFailure(state) {
        state.listOutput = false;
    },
    /* Detail */
    listDetailRequest(state) {
        state.detailOutput = null;
    },
    listDetailSuccess(state, output) {
        setTimeout(() => state.detailOutput = output, 1000);
    },
    listDetailFailure(state) {
        state.detailOutput = false;
    }
};

export const oliveOil = {
    namespaced: true,
    state,
    actions,
    mutations
};